export default __webpack_public_path__ + "static/media/MeusContratos.89a32ee0.svg";